import { environment } from '../../environments/environment';
const modulesMenu = [
    {
        label: $localize `Moduli`,
        items: [
            {
                label: $localize `Kalkulator`,
                icon: 'fa-solid fa-calculator',
                routerLink: '/label/calc'
            },
            // {
            //   label: $localize`Obrazci`,
            //   routerLink: '/forms',
            //   icon: 'fa-solid fa-edit',
            // },
            // {
            //   label: $localize`Dokumenti`,
            //   routerLink: '/folders',
            //   icon: 'fa-solid fa-folder',
            // },
            {
                label: $localize `Reklamacije`,
                routerLink: '/orders/complaints',
                icon: 'fa-solid fa-circle-radiation',
            },
            {
                label: $localize `Obvestila`,
                routerLink: '/messaging',
                icon: 'fa-solid fa-message',
            },
            // {
            //   label: $localize`Potrjevanje`,
            //   routerLink: '/approvals',
            //   icon: 'fa-solid fa-thumbs-up',
            // },
            {
                label: $localize `Proizvodnja`,
                routerLink: '/cost-center/usage',
                icon: 'fa-solid fa-industry',
            },
            {
                label: $localize `Ankete`,
                routerLink: '/vote',
                icon: 'fa-solid fa-poll-h',
            },
        ],
    }
];
export const adminMenuItems = [
    {
        label: environment.title,
        items: [
            {
                label: $localize `Naročila`,
                icon: 'fa-solid fa-cart-shopping',
                routerLink: '/orders',
                items: [
                    {
                        label: $localize `Novo`,
                        icon: 'fa-solid fa-plus',
                        routerLink: '/orders/new',
                    },
                    {
                        label: $localize `Pregled`,
                        icon: 'fa-solid fa-list-ul',
                        routerLink: '/orders',
                    },
                    ...(environment.layout === 'new' ? [
                        {
                            label: $localize `Podpisovanje`,
                            routerLink: '/signature',
                            icon: 'fa-solid fa-signature',
                        },
                    ] : []),
                    ...(environment.layout === 'new' ? [
                        {
                            label: $localize `Statistika`,
                            icon: 'fa-solid fa-pie-chart',
                            routerLink: '/dashboard',
                        },
                    ] : []),
                ]
            },
            ...(environment.layout === 'new' ? [
                {
                    label: $localize `Opravila`,
                    icon: 'fa-solid fa-tasks',
                    routerLink: '/tasks',
                },
            ] : []),
            ...(environment.layout === 'new' ? [
                {
                    label: $localize `Opravila`,
                    icon: 'fa-solid fa-tasks',
                    routerLink: '/tasks',
                },
            ] : []),
            {
                label: $localize `Nastavitve`,
                icon: 'fa-solid fa-sliders',
                items: [
                    {
                        label: $localize `Statusi`,
                        icon: 'fa-solid fa-eye',
                        routerLink: '/settings/status',
                    },
                    {
                        label: $localize `Prioritete`,
                        icon: 'fa-solid fa-bell',
                        routerLink: '/settings/priorities',
                    },
                    {
                        label: $localize `Materiali`,
                        icon: 'fa-solid fa-toilet-paper',
                        routerLink: '/settings/materials',
                    },
                    {
                        label: $localize `Dimenzije`,
                        icon: 'fa-solid fa-ruler-horizontal',
                        routerLink: '/settings/dimensions',
                    },
                    {
                        label: $localize `Formati`,
                        icon: 'fa-solid fa-map',
                        routerLink: '/formats',
                    },
                    {
                        label: $localize `Polja po meri`,
                        icon: 'fa-solid fa-pen-to-square',
                        routerLink: '/settings/custom-fields',
                    },
                    {
                        label: $localize `Procesi`,
                        icon: 'fa-solid fa-table',
                        routerLink: '/settings/organizer',
                    },
                    {
                        label: $localize `Predloge`,
                        icon: 'fa-solid fa-envelope-open-text',
                        routerLink: '/settings/templates'
                    },
                    {
                        label: $localize `Tagi`,
                        icon: 'fa-solid fa-tags',
                        routerLink: '/settings/tags'
                    },
                    {
                        label: $localize `Stroškovna mesta`,
                        icon: 'fa-solid fa-print',
                        routerLink: '/cost-center'
                    },
                    {
                        label: $localize `Skupine produktov`,
                        icon: 'fa-solid fa-briefcase',
                        routerLink: '/product-groups'
                    },
                    {
                        label: $localize `Sistem`,
                        icon: 'fa-solid fa-gear',
                        routerLink: '/settings/system',
                    }
                ],
            },
            {
                label: $localize `Izdelki`,
                icon: 'fa-solid fa-industry',
                routerLink: '/izdelki',
            },
            {
                label: $localize `Uporabniki`,
                icon: 'fa-solid fa-user',
                routerLink: '/users',
            },
            {
                label: 'Stranke',
                icon: 'fa-solid fa-users',
                routerLink: '/customers'
            },
            // {
            //   label: $localize`Planiranje`,
            //   routerLink: '/planning',
            //   icon: 'fa-solid fa-check-square'
            // },
            ...(environment.layout === 'new' ? [
                {
                    label: $localize `Projekti`,
                    routerLink: '/projects',
                    icon: 'fa-solid fa-briefcase',
                },
            ] : []),
            ...(environment.layout === 'new' ? [
                {
                    label: $localize `Podpisovanje`,
                    routerLink: '/signature',
                    icon: 'fa-solid fa-signature',
                },
            ] : []),
            // {
            //   label: $localize`Baza znanja`,
            //   routerLink: '/knowledge',
            //   icon: 'fa-solid fa-book',
            // },
            // {
            //   label: $localize`Info`,
            //   routerLink: '/info',
            //   icon: 'fa-solid fa-circle-info',
            // },
            // {
            //   label: $localize`Prisotnost`,
            //   routerLink: '/hours',
            //   icon: 'fa-solid fa-clock'
            // }
        ]
    },
    {
        label: $localize `Procesi`,
        routerLink: '/procesi'
    },
    {
        label: $localize `Naročila`,
        routerLink: '/orders'
    },
    ...(environment.layout === 'new' ? modulesMenu : []),
    ...(environment.layout === 'new' ?
        [
            {
                label: undefined,
                icon: 'fa-solid fa-calendar',
                routerLink: '/organizer/cal',
                tooltip: $localize `Koledarski pogled`
            },
            {
                label: undefined,
                icon: 'fa-solid fa-plus',
                routerLink: '/orders/new',
                tooltip: $localize `Novo naročilo`
            },
            {
                label: undefined,
                icon: 'fa-solid fa-paste',
                routerLink: '/clip',
                tooltip: $localize `Odložišče`,
                tooltipPosition: 'bottom',
            },
        ] : []),
];
export const editorMenuItems = [
    {
        label: environment.title,
        items: [
            {
                label: $localize `Naročila`,
                icon: 'fa-solid fa-cart-shopping',
                routerLink: '/orders',
                items: [
                    {
                        label: $localize `Novo`,
                        icon: 'fa-solid fa-plus',
                        routerLink: '/orders/new',
                    },
                    {
                        label: $localize `Pregled`,
                        icon: 'fa-solid fa-list-ul',
                        routerLink: '/orders',
                    },
                ]
            },
            {
                label: $localize `Opravila`,
                icon: 'fa-solid fa-tasks',
                routerLink: '/tasks',
            },
        ]
    },
    {
        label: $localize `Procesi`,
        routerLink: '/procesi'
    },
    {
        label: $localize `Naročila`,
        routerLink: '/orders'
    },
    ...(environment.layout === 'new' ? modulesMenu : []),
    ...(environment.layout !== 'new' ? [
        {
            label: undefined,
            icon: 'fa-solid fa-calendar',
            routerLink: '/procesi/cal',
            tooltip: $localize `Koledarski pogled`,
        },
        {
            label: undefined,
            icon: 'fa-solid fa-plus',
            routerLink: '/orders/new',
            tooltip: $localize `Novo naročilo`,
            tooltipPosition: 'bottom',
        },
        /* {
          label: undefined,
          icon: 'fa-solid fa-paste',
          routerLink: '/clip',
          tooltip:  $localize`Odložišče`,
          tooltipPosition: 'bottom',
        }, */
    ] : []),
];
if (environment.calendar && environment.layout !== 'new') {
    const calendarMenuItem = {
        label: $localize `Koledar`,
        routerLink: '/calendar'
    };
    editorMenuItems.push(calendarMenuItem);
    adminMenuItems.push(calendarMenuItem);
}
export const externalMenuItems = [
    {
        label: $localize `Naročila`,
        routerLink: '/orders'
    },
    {
        label: $localize `Opravila`,
        icon: 'fa-solid fa-tasks',
        routerLink: '/tasks',
    },
];
export const customerMenuItems = [
    {
        label: $localize `Naročila`,
        routerLink: '/orders'
    }
];
